/**
 * Created by karthikeyan.k on 30-11-2018.
 */
export class GameConstant {
  private static currentTableId = '';
  public static get FCB(): string {
    return 'fcb';
  }

  public static get FC21(): string {
    return 'fc21';
  }

  public static get FC21RNGTYPEID(): string {
    return 'rngfcg21ornothing';
  }

  public static get FCGRNGTYPEID(): string {
    return 'rngfcg21ornothing';
  }

  public static get FCBRNGTYPEID(): string {
    return 'rngfcgbaccarat';
  }

  public static get FC21LIVEDEALERTYPEID(): string {
    // return '0000000000000604';
    return '0000000000000606';
  }

  public static get FCBLIVEDEALERTYPEID(): string {
    //return '0000000000000605';
    return '0000000000000607';
  }

  public static get LIVEFC21LIVEDEALERTABLEID(): string {
    return this.currentTableId;
  }

  public static get LIVEFC21LIVEDEALERTYPEID(): string {
    return '0000000000000606';
  }

  public static get FC21LIVEDEALERTABLEID(): string {
    return this.currentTableId;
    //return 'fcg21nv8sv7rk1jk';
    // return 'fcg1w5h2dzb87trt';
  }

  public static set FC21LIVEDEALERTABLEID(tableId: string) {
    this.currentTableId = tableId;
  }

  public static get FCBLIVEDEALERTABLEID(): string {
    return 'fcg54bac237rk1tc';
    // return 'fcg1w5h2dzb7b2rt';
  }
}
